var coords = require('notecoord');

var accval = require('accidental-value');

module.exports = function helmholtz(name) {
  var name = name.replace(/\u2032/g, "'").replace(/\u0375/g, ',');
  var parts = name.match(/^(,*)([a-h])(x|#|bb|b?)([,\']*)$/i);
  if (!parts || name !== parts[0]) throw new Error('Invalid formatting');
  var note = parts[2];
  var octaveFirst = parts[1];
  var octaveLast = parts[4];
  var lower = note === note.toLowerCase();
  var octave;

  if (octaveFirst) {
    if (lower) throw new Error('Invalid formatting - found commas before lowercase note');
    octave = 2 - octaveFirst.length;
  } else if (octaveLast) {
    if (octaveLast.match(/^'+$/) && lower) octave = 3 + octaveLast.length;else if (octaveLast.match(/^,+$/) && !lower) octave = 2 - octaveLast.length;else throw new Error('Invalid formatting - mismatch between octave ' + 'indicator and letter case');
  } else octave = lower ? 3 : 2;

  var accidentalValue = accval.interval(parts[3].toLowerCase());
  var coord = coords(note.toLowerCase());
  coord[0] += octave;
  coord[0] += accidentalValue[0] - coords.A4[0];
  coord[1] += accidentalValue[1] - coords.A4[1];
  return coord;
};